<div class="data-area">
    <table class="table table-hover table-inline-edit">
        <thead class="thead-light">
            <tr>
                <th>Date</th>
                <th>Title</th>
                <th>Video URL</th>
                <th>Description</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr videosRow [isEditVideo]="false" (onSave)="addVideo($event)"></tr>

            <tr videosRow *ngFor="let video of sortedvideos" 
                [isEditVideo]="true" 
                [video]="video"
                (onEditing)="updateVideo($event)" 
                (onDelete)="delete($event)">
            </tr>
        </tbody>
    </table>
</div>

<app-confirm-delete-modal-component #confirmDeleteModal></app-confirm-delete-modal-component>